// Bilingual translation strings for Cloud Beauty
export const translations = {
  ar: {
    dir: "rtl",
    brand: "كلاود بيوتي",
    nav: {
      home: "الرئيسية",
      services: "الخدمات",
      offers: "العروض",
      book: "احجزي الآن",
      myBookings: "حجوزاتي",
      contact: "تواصل معنا",
    },
    common: {
      bookNow: "احجزي الآن",
      viewAll: "عرض الكل",
      sar: "ريال",
      minutes: "دقيقة",
      loading: "جارٍ التحميل...",
      next: "التالي",
      back: "السابق",
      confirm: "تأكيد",
      cancel: "إلغاء",
      save: "حفظ",
      close: "إغلاق",
      from: "من",
      addToBooking: "أضيفي للحجز",
      added: "تمت الإضافة",
      empty: "لا يوجد بيانات لعرضها",
      error: "حدث خطأ، حاولي مرة أخرى",
      print: "طباعة الفاتورة",
      search: "بحث",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
    },
    home: {
      featured: "خدماتنا المميزة",
      featuredSub: "باقة متكاملة من خدمات العناية والجمال",
      offersTitle: "عروضنا الحالية",
      offersSub: "استمتعي بأفضل العروض لفترة محدودة",
      whyTitle: "لماذا كلاود بيوتي؟",
      whySub: "تجربة عناية تستحقينها",
      reviewsTitle: "آراء عميلاتنا",
      reviewsSub: "ثقتكِ هي أجمل ما نحصده",
      contactTitle: "تواصلي معنا",
      contactSub: "نسعد بخدمتك في أي وقت",
    },
    services: {
      title: "خدماتنا",
      subtitle: "اختاري الخدمة التي تناسبكِ واستمتعي بتجربة فريدة من نوعها",
      all: "جميع الخدمات",
      duration: "المدة",
      unavailable: "غير متاحة حالياً",
    },
    offers: {
      title: "العروض الحصرية",
      subtitle: "دللي نفسكِ بأفضل العروض والخصومات",
      was: "السعر السابق",
      now: "السعر الآن",
      expires: "ينتهي في",
      bookOffer: "احجزي العرض",
      none: "لا توجد عروض متاحة حالياً",
    },
    booking: {
      title: "احجزي موعدكِ",
      step1: "الخدمة",
      step2: "الموعد",
      step3: "البيانات",
      step4: "الملخص",
      step5: "التأكيد",
      chooseServices: "اختاري الخدمات التي ترغبين بها",
      details: "تفاصيل الحجز",
      subtotal: "المجموع الكلي",
      addMore: "إضافة خدمة أخرى",
      chooseDate: "اختاري التاريخ",
      chooseTime: "اختاري الوقت",
      noSlots: "لا توجد مواعيد متاحة في هذا اليوم",
      selectDateFirst: "اختاري التاريخ أولاً لعرض المواعيد",
      yourInfo: "بياناتكِ",
      fullName: "الاسم الكامل",
      phone: "رقم الجوال",
      email: "البريد الإلكتروني",
      notes: "ملاحظات (اختياري)",
      contactMethod: "طريقة التواصل المفضلة",
      whatsapp: "واتساب",
      call: "مكالمة",
      summary: "ملخص الحجز",
      discount: "الخصم",
      total: "الإجمالي النهائي",
      agree: "أوافق على سياسة الحجز وسياسة الإلغاء",
      paymentMethod: "طريقة الدفع",
      payAtSalon: "الدفع في الصالون",
      payOnline: "الدفع الآن أونلاين",
      confirmBooking: "تأكيد الحجز",
      successTitle: "تم تأكيد حجزكِ بنجاح!",
      successSub: "لقد أرسلنا تفاصيل الحجز إلى بريدك الإلكتروني",
      reference: "رقم الحجز",
      selectServicesFirst: "اختاري خدمة واحدة على الأقل",
      newBooking: "حجز جديد",
    },
    my: {
      title: "حجوزاتي",
      subtitle: "أدخلي رقم الحجز ورقم الجوال لعرض تفاصيل حجزك",
      reference: "رقم الحجز",
      phone: "رقم الجوال",
      lookup: "بحث عن الحجز",
      status: "الحالة",
      notFound: "لم يتم العثور على حجز مطابق",
      cancelBooking: "إلغاء الحجز",
      cancelled: "تم إلغاء الحجز",
      confirmCancel: "هل أنتِ متأكدة من إلغاء الحجز؟",
      reschedule: "تغيير الموعد",
      rescheduleTitle: "اختاري موعداً جديداً",
      rescheduleConfirm: "تأكيد الموعد الجديد",
      rescheduled: "تم تغيير موعد حجزكِ بنجاح",
      rescheduleLeft: "متبقي لكِ {n} من 2 تغيير",
      rescheduleRule: "تغيير الموعد متاح قبل الموعد بـ 24 ساعة على الأقل، وبحد أقصى مرتين",
      rescheduleLimit: "وصلتِ للحد الأقصى لتغيير الموعد",
      rescheduleTooLate: "لا يمكن تغيير الموعد قبل أقل من 24 ساعة",
    },
    status: {
      pending: "قيد المراجعة",
      confirmed: "مؤكد",
      cancelled: "ملغي",
      rejected: "مرفوض",
      completed: "مكتمل",
      awaiting_payment: "بانتظار الدفع",
    },
    payment: {
      unpaid: "غير مدفوع",
      paid: "مدفوع",
      pay_at_salon: "الدفع في الصالون",
      refunded: "مسترد",
    },
    footer: {
      about: "صالون كلاود بيوتي للعناية والجمال، نمنحكِ تجربة استرخاء وجمال لا تُنسى.",
      quickLinks: "روابط سريعة",
      contactUs: "تواصلي معنا",
      rights: "جميع الحقوق محفوظة",
    },
    admin: {
      login: "تسجيل دخول الإدارة",
      dashboard: "لوحة التحكم",
    },
  },
  en: {
    dir: "ltr",
    brand: "Cloud Beauty",
    nav: {
      home: "Home",
      services: "Services",
      offers: "Offers",
      book: "Book Now",
      myBookings: "My Bookings",
      contact: "Contact",
    },
    common: {
      bookNow: "Book Now",
      viewAll: "View All",
      sar: "SAR",
      minutes: "min",
      loading: "Loading...",
      next: "Next",
      back: "Back",
      confirm: "Confirm",
      cancel: "Cancel",
      save: "Save",
      close: "Close",
      from: "From",
      addToBooking: "Add to booking",
      added: "Added",
      empty: "Nothing to show",
      error: "Something went wrong, try again",
      print: "Print Invoice",
      search: "Search",
      login: "Login",
      logout: "Logout",
    },
    home: {
      featured: "Featured Services",
      featuredSub: "A complete collection of beauty & care services",
      offersTitle: "Current Offers",
      offersSub: "Enjoy our best offers for a limited time",
      whyTitle: "Why Cloud Beauty?",
      whySub: "A pampering experience you deserve",
      reviewsTitle: "Client Reviews",
      reviewsSub: "Your trust is our greatest reward",
      contactTitle: "Get In Touch",
      contactSub: "We're happy to serve you anytime",
    },
    services: {
      title: "Our Services",
      subtitle: "Choose the service that suits you and enjoy a unique experience",
      all: "All Services",
      duration: "Duration",
      unavailable: "Currently unavailable",
    },
    offers: {
      title: "Exclusive Offers",
      subtitle: "Treat yourself with our best offers and discounts",
      was: "Was",
      now: "Now",
      expires: "Expires",
      bookOffer: "Book Offer",
      none: "No offers available right now",
    },
    booking: {
      title: "Book Your Appointment",
      step1: "Service",
      step2: "Date",
      step3: "Details",
      step4: "Summary",
      step5: "Done",
      chooseServices: "Choose the services you want",
      details: "Booking Details",
      subtotal: "Subtotal",
      addMore: "Add another service",
      chooseDate: "Choose a date",
      chooseTime: "Choose a time",
      noSlots: "No available slots for this day",
      selectDateFirst: "Select a date first to see available times",
      yourInfo: "Your Details",
      fullName: "Full Name",
      phone: "Mobile Number",
      email: "Email Address",
      notes: "Notes (optional)",
      contactMethod: "Preferred contact method",
      whatsapp: "WhatsApp",
      call: "Call",
      summary: "Booking Summary",
      discount: "Discount",
      total: "Final Total",
      agree: "I agree to the booking & cancellation policy",
      paymentMethod: "Payment method",
      payAtSalon: "Pay at salon",
      payOnline: "Pay online now",
      confirmBooking: "Confirm Booking",
      successTitle: "Your booking is confirmed!",
      successSub: "We've sent the booking details to your email",
      reference: "Booking Reference",
      selectServicesFirst: "Select at least one service",
      newBooking: "New Booking",
    },
    my: {
      title: "My Bookings",
      subtitle: "Enter your reference and phone number to view your booking",
      reference: "Booking Reference",
      phone: "Mobile Number",
      lookup: "Find Booking",
      status: "Status",
      notFound: "No matching booking found",
      cancelBooking: "Cancel Booking",
      cancelled: "Booking cancelled",
      confirmCancel: "Are you sure you want to cancel?",
      reschedule: "Reschedule",
      rescheduleTitle: "Choose a new time",
      rescheduleConfirm: "Confirm new time",
      rescheduled: "Your booking was rescheduled",
      rescheduleLeft: "{n} of 2 changes left",
      rescheduleRule: "You can reschedule up to 24 hours before your appointment, max 2 times",
      rescheduleLimit: "Reschedule limit reached",
      rescheduleTooLate: "Rescheduling closes 24 hours before the appointment",
    },
    status: {
      pending: "Pending",
      confirmed: "Confirmed",
      cancelled: "Cancelled",
      rejected: "Rejected",
      completed: "Completed",
      awaiting_payment: "Awaiting Payment",
    },
    payment: {
      unpaid: "Unpaid",
      paid: "Paid",
      pay_at_salon: "Pay at salon",
      refunded: "Refunded",
    },
    footer: {
      about: "Cloud Beauty salon gives you an unforgettable beauty and relaxation experience.",
      quickLinks: "Quick Links",
      contactUs: "Contact Us",
      rights: "All rights reserved",
    },
    admin: {
      login: "Admin Login",
      dashboard: "Dashboard",
    },
  },
};

export const THEMES = {
  cloud_sky: {
    name_ar: "كلاود سكاي", name_en: "Cloud Sky", mode: "light",
    background: "#F4F8FB", foreground: "#1E2A38", card: "#FFFFFF",
    primary: "#3B7182", primaryFg: "#FFFFFF", secondary: "#D9EAFD", secondaryFg: "#1E2A38",
    muted: "#EBF2F7", mutedFg: "#5C7080", accent: "#5B92A8", accentFg: "#FFFFFF", border: "#D2E2EE",
  },
  cloud_beige: {
    name_ar: "كلاود بيج", name_en: "Cloud Beige", mode: "light",
    background: "#F6F1EA", foreground: "#3A342E", card: "#FFFFFF",
    primary: "#5E7681", primaryFg: "#FFFFFF", secondary: "#E7DFD4", secondaryFg: "#3A342E",
    muted: "#F0EAE1", mutedFg: "#7A7166", accent: "#8AA1A9", accentFg: "#FFFFFF", border: "#E3D8C9",
  },
  cloud_luxe: {
    name_ar: "كلاود لوكس", name_en: "Cloud Luxe", mode: "dark",
    background: "#12100E", foreground: "#FAF7F2", card: "#1C1917",
    primary: "#D4AF37", primaryFg: "#1C1917", secondary: "#2B2623", secondaryFg: "#FAF7F2",
    muted: "#26211E", mutedFg: "#A89F91", accent: "#E2C364", accentFg: "#1C1917", border: "#3A332C",
  },
};
